<div class="panel-head-wrapper">
    <button mat-icon-button (click)="slideDrawer.toggle()">
        <mat-icon>close</mat-icon>
      </button>
</div>

<div class="slides" [dndDropzone]="['slidenavpanel']" (dndDrop)="drop($event)">      
    <!-- placeholder -->
    <div dndPlaceholderRef class="dndPlaceholder slide mat-elevation-z2 clearfix" [innerHTML]="slidenav.placeholder">
        <div class="inner"></div>
    </div>
    <!-- slide -->
    <div 
        dndType="slidenavpanel"
        [dndDraggable]="i"
        [dndEffectAllowed]="'move'"
        [dndDisableIf]="item.intro || item.outro || slidenav.slideshow.locked || searchText"
        (dndStart)="slidenav.dragStart($event)"
        #slidenavpanel
        *ngFor="let item of slidenav.slideshow.slides; let i = index; trackBy: slidenav.utils.trackByIndex;" 
        [attr.data-index]="i"
        [ngClass]="markedForDeletion[i]"
        class="slide clearfix {{item.status == 'draft' && slidenav.slideshow.assignment.status == 'publish' ? 'unpublished' : ''}} {{item.intro ? 'intro' : ''}} {{item.outro ? 'outro' : ''}} {{item.blacklist.length && !slidenav.slideshow.locked ? 'blacklisted' : ''}}">
        <span class="delete" *ngIf="!slidenav.slideshow.locked && !item.intro && (!slidenav.slideshow.quiz || (slidenav.slideshow.quiz && !item.intro && !item.outro))" (click)="markForDelete(i)"><mat-icon>delete_outline</mat-icon></span>
        <div class="inner" (click)="slidenav.navigate(item)" title="{{item.title}}">
            <div class="no-event">
                <span class="slide-no handle">{{slidenav.getSlideNumber(item)}}</span>
                <span class="image">
                    <span 
                        *ngIf="item.images.length > 0 && (!slidenav.slideshow.quiz || (slide && !slide.outro)); else imgicon"
                        [attr.data-image-id]="item.images[0].id"
                        [attr.data-image-size]="'thumbnail'"
                        class="bg"
                        [ngStyle]="{
                            'background-image' : 'url(\'' + item.images[0].sizes?.thumbnail?.urlWithParams + '\')'
                        }">
                    </span>
                    <ng-template #imgicon>
                        <span class="icon faded">
                            <mat-icon>insert_photo</mat-icon> 
                        </span>
                    </ng-template>
                </span>
                <span class="content">
                    <span class="title" [innerHTML]="item.title"></span>
                    <span class="excerpt">
                        <span [innerHTML]="slidenav.getContent(item)"></span>
                    </span>
                </span>
                <span class="slide-id">ID: {{item.id}}</span>
                <span class="teaser faded" *ngIf="item.teaser"><mat-icon>chat</mat-icon></span>                  
            </div>
        </div>
    </div>
    <div *ngIf="readyToDelete" class="fab-buttons">
        <button 
            mat-fab 
            color="warn" 
            class="delete-button"
            matTooltip="Delete all selected slides"
            [matTooltipPosition]="above"
            (click)="deleteSelected()">
            <mat-icon>delete</mat-icon>
        </button>
        <button 
            mat-mini-fab 
            color="accent" 
            class="clear-button"
            matTooltip="Clear all slides selected for deletion"
            [matTooltipPosition]="above"
            (click)="clearSelection()">
            <mat-icon>clear_all</mat-icon>
        </button>
    </div>
    <div class="slide loading" *ngIf="slidenav.loading">
        loading...
    </div>
</div>